import classNames from "classnames";
import { noop, partial } from "lodash";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { useChatContext } from "~/ui/context";
import { useScreenMd } from "~/utils";

import { Icon } from "../../icons";
import { ChatConversations } from "./ChatConversations/ChatConversations";

export const ChatLeftMenu: FC = () => {
  const { isMenuOpened, setIsMenuOpened } = useChatContext();
  const isDesktop = useScreenMd();

  return (
    <div
      className={classNames(
        "h-full border-right-sm bg-light z-index-1020 ",
        isMenuOpened
          ? !isDesktop
            ? "w-100 absolute zIndex-50 h-full"
            : "w-30 w-min-210px "
          : !isDesktop
          ? "display-none"
          : "w-5",
        !isMenuOpened && "pointer"
      )}
      onClick={isMenuOpened ? noop : partial(setIsMenuOpened, true)}
    >
      <div
        className={classNames(
          "flex items-center pointer h-5 h-min-5",
          !isMenuOpened
            ? "justify-center w-100 pd-t-md"
            : "justify-between border-bottom pd-md"
        )}
        onClick={partial(setIsMenuOpened, !isMenuOpened)}
      >
        {isMenuOpened && (
          <div className="flex items-center gap-md">
            <Icon icon={["fab", "rocketchat"]} size="lg" />
            <h6>
              <FormattedMessage defaultMessage="Chats" id="ABAQyo" />
            </h6>
          </div>
        )}
        <Icon icon={["fal", "bars"]} className="nav-menu-icon" />
      </div>

      {isMenuOpened && <ChatConversations />}
    </div>
  );
};
